import PropTypes from 'prop-types';
import {useFeatureFlag} from '../../hooks/useFeatureFlag.js';

const FeatureFlag = ({code, fallback = null, children}) => {
  const isVisible = useFeatureFlag(code);

  return isVisible ? children : fallback;
};

FeatureFlag.propTypes = {
  code: PropTypes.string.isRequired,
  fallback: PropTypes.node,
  children: PropTypes.node,
};

export default FeatureFlag;
